import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPageLayout = get('reservation.components.pageLayout');

export const getSidebarNavExpanded = createSelector(
  getPageLayout,
  get('sidebarNavExpanded')
);
